// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".container[data-v-055b2902] {\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n}\n.container__body[data-v-055b2902] {\n  flex: 1;\n}", ""]);
// Exports
module.exports = exports;
